import i18n from "../i18n";
import React from "react";
import { TextInput, Button, Anchor } from "@mantine/core";
import { IconExclamationMark, IconCircleCheck, IconMail } from "@tabler/icons";
import { Link, useNavigate } from "react-router-dom";
import AuthSplitLayout, { authFieldStyles } from "../components/authSplitLayout";

import { useForm } from "@mantine/form";
import { useServerApi } from "../hooks/userServerApi";
import { showNotification } from "@mantine/notifications";

const ForgetPassword = () => {
  const title = "Reset Your Password";
  const [api] = useServerApi();
  const navigate = useNavigate();

  const form = useForm({
    initialValues: {
      email: "",
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
    },
  });

  const handleError = ({ message }) => {
    let msg = "";
    switch (message) {
      case "ERR_NO_USER":
        msg = "No this user";
        break;
      case "ERR_USER_INACTIVE":
        msg = "The user is inactive";
        break;
      case "ERR_INVALID_PASSWORD":
        msg = "Invalid password";
        break;
      default:
        msg = message;
        break;
    }

    return showNotification({
      title: "Login Fail",
      color: "red",
      icon: <IconExclamationMark size={18} />,
      message: msg,
    });
  };

  const handleReset = async ({ email }) => {
    // console.log(values);
    try {
      const result = await api.User.resetPassword(email);
      // console.log(result);
      navigate("/login");
      return showNotification({
        title: "Password Reset",
        color: "green",
        icon: <IconCircleCheck size={18} />,
        message: "New password has been sent to your email.",
      });
      return;
    } catch (error) {
      console.log(error);
      return showNotification({
        title: "Login Fail",
        color: "red",
        icon: <IconExclamationMark size={18} />,
        message: error.msg,
      });
    }
  };

  return (
    <AuthSplitLayout
      title={title}
      subtitle="Enter your official email and we will send a reset password email."
    >
      <form onSubmit={form.onSubmit((values) => handleReset(values))}>
        <TextInput
          label="Email"
          placeholder="your@email.com"
          required
          icon={<IconMail size={18} />}
          styles={authFieldStyles}
          {...form.getInputProps("email")}
        />

        <Button
          fullWidth
          mt="xl"
          type="submit"
          radius={10}
          sx={{
            height: 44,
            backgroundColor: "#0e8a84",
            "&:hover": { backgroundColor: "#0c756e" },
          }}
        >
          {i18n.t("Reset Password")}
        </Button>
        <Anchor
          component={Link}
          to="/login"
          size="sm"
          sx={{
            display: "block",
            textAlign: "center",
            marginTop: 16,
            color: "#0c756e",
            fontWeight: 500,
          }}
        >
          Back to sign in
        </Anchor>
      </form>
    </AuthSplitLayout>
  );
};

export default ForgetPassword;
